import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRDocumentFormData = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument
)
